import * as tslib_1 from "tslib";
/* tslint:disable */
import * as React from 'react';
/* tslint:enable */
import { styled } from '../../../Utilities';
import { BasePicker } from '../BasePicker';
import { getStyles } from '../BasePicker.styles';
import { TagItem } from './TagItem';
import { TagItemSuggestion } from './TagItemSuggestion';
var TagPickerBase = /** @class */function (_super) {
  tslib_1.__extends(TagPickerBase, _super);
  function TagPickerBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TagPickerBase.defaultProps = {
    onRenderItem: function onRenderItem(props) {
      return React.createElement(TagItem, tslib_1.__assign({}, props), props.item.name);
    },
    onRenderSuggestionsItem: function onRenderSuggestionsItem(props) {
      return React.createElement(TagItemSuggestion, null, props.name);
    }
  };
  return TagPickerBase;
}(BasePicker);
export { TagPickerBase };
export var TagPicker = styled(TagPickerBase, getStyles, undefined, {
  scope: 'TagPicker'
});